import {toast} from 'react-toastify'
import {useParams} from 'react-router-dom'

import {useUserAgentQuery} from '@sdox/api'

export const useFolderShare = () => {
  const {data} = useUserAgentQuery()
  const {basePath, seFolderSlug} = useParams()
  const folderUrl = `${window.location.origin}/${basePath}/${seFolderSlug}`

  const shareText = `Wie findest du diese Vorschläge? ${folderUrl}`
  const shareTitle = 'Mein neues Auto'
  const emailLink = `mailto:?body=${encodeURI(shareText)}&subject=${encodeURI(shareTitle)}`

  const openMail = (): void => {
    window.location.href = emailLink
    toast.info('E-Mail-Programm wird geöffnet', {hideProgressBar: false, autoClose: 2000})
  }

  const shareData = {text: shareText, title: shareTitle, url: folderUrl}

  const canNativeShare = data?.userAgent.isMobile && navigator.share !== undefined

  const nativeShare = () => {
    if (canNativeShare) {
      // available only in secure context! (HTTPS)
      navigator.share(shareData).catch(e => console.log(e))
    }
  }

  return {
    folderUrl,
    openMail,
    canNativeShare,
    nativeShare,
  }
}
